import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {LoadingProvider} from "./components/context/LoadingContext";
import {AuthProvider} from "./components/context/authContext/AuthContext";
import {BrowserRouter} from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <LoadingProvider>
        <AuthProvider>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </AuthProvider>
    </LoadingProvider>,
);
